<template>
  <div>
    <b-row>
      <b-col md="3" lg="3" xl="3">
        <b-table
          show-empty
          selectable
          ref="leftTable"
          select-mode="single"
          head-variant="light"
          class="bg-white"
          sticky-header="500px"
          :busy="leftLoading"
          :fields="leftTableDataFields"
          :items="leftTableData"
          @row-selected="leftClick"
        >
          <template v-slot:cell(label)="{ item }">
            <div style="cursor: pointer">
              <b-icon
                class="mr-1"
                icon="folder-fill"
                variant="warning"
              ></b-icon>
              <span>
                {{ item.label ? item.label : "--" }}
                ({{ item.labelEn ? item.labelEn : "--" }})
              </span>
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l("INDEX.tips_no_data") || "暂无数据！" }}
              </p>
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col md="9" lg="9" xl="9">
        <b-table
          hover
          show-empty
          head-variant="light"
          class="bg-white"
          :busy="loading"
          ref="table"
          :fields="tableDataFields"
          :items="tableData"
        >
          <template v-slot:cell(fabricAttrStatus)="data">
            <b-badge
              :variant="
                data.item.fabricAttrStatus === 'Y' ? 'success' : 'danger'
              "
              >{{ data.item.fabricAttrStatusName }}</b-badge
            >
          </template>
          <template v-slot:cell(operation)="data">
            <b-button-group>
              <b-button
                class="mr-2"
                v-b-tooltip.hover
                :title="$l('tips_view') || '查看'"
                @click="fromLoad('detail', data.item.fabricAttrCode)"
                variant="outline-secondary"
                size="sm"
              >
                <b-icon-eye></b-icon-eye>
              </b-button>
              <b-button
                class="mr-2"
                v-b-tooltip.hover
                :title="$l('tips_edit') || '编辑'"
                @click="fromLoad('edit', data.item.fabricAttrCode)"
                variant="outline-secondary"
                size="sm"
                v-if="allow('M')"
              >
                <b-icon-pencil></b-icon-pencil>
              </b-button>
              <b-button
                v-b-tooltip.hover
                v-show="data.item.fabricAttrStatus === 'Y'"
                :title="$l('tips_del') || '删除'"
                @click="update(data.item.fabricAttrCode, 'N')"
                variant="outline-secondary"
                size="sm"
                v-if="allow('D')"
              >
                <b-icon-trash-fill></b-icon-trash-fill>
              </b-button>
              <b-button
                v-show="data.item.fabricAttrStatus !== 'Y'"
                v-b-tooltip.hover
                :title="$l('tips_reset') || '恢复'"
                @click="update(data.item.fabricAttrCode, 'Y')"
                variant="outline-secondary"
                size="sm"
                v-if="allow('D')"
              >
                <b-icon-arrow-repeat></b-icon-arrow-repeat>
              </b-button>
            </b-button-group>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l("INDEX.tips_no_data") || "暂无数据！" }}
              </p>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <page-detail
        ref="form"
        :params="params"
        @success="saveSuccess"
      ></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l("form_button_cancel") || "取消"
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l("form_button_save") || "保存" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    PageDetail: () => import("../../components/detail"),
  },
  props: {
    tableData: {
      default: () => [],
    },
    leftTableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    leftLoading: {
      default: false,
    },
  },
  data() {
    return {
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      leftTableDataFields: [
        {
          key: "label",
          label: this.$l("table_label_name_left") || "类型名称",
          tdClass: "align-middle",
        },
      ],
      tableDataFields: [
        {
          key: "fabricAttrValueCn",
          label: this.$l("table_label_name_cn") || "属性值中文",
          tdClass: "align-middle",
        },
        {
          key: "fabircAttrValueEn",
          label: this.$l("table_label_name_en") || "属性值英文",
          tdClass: "align-middle",
        },
        {
          key: "fabricAttrTypeCn",
          label: this.$l("table_label_name_type") || "属性类型",
          tdClass: "align-middle",
        },
        {
          key: "fabricCategoryFullNameEn",
          label: this.$l("table_label_name_category_full_name") || "分类",
          tdClass: "align-middle",
        },
        {
          key: "fabricAttrStatus",
          label: this.$l("table_label_status") || "状态",
          tdClass: "align-middle",
        },
        // {
        //   key: "modifyInfo",
        //   label: this.$l("table_label_modifyInfo") || "修改信息",
        //   tdClass: "align-middle",
        // },
        {
          key: "operation",
          label: this.$l("table_label_operation") || "操作",
          tdClass: "align-middle",
        },
      ],
      params: {
        fabricAttrTypeEn: "", //类型内码值
        fabricAttrTypeCn: "", //名称
      },
    };
  },
  methods: {
    leftClick(val) {
      if (val[0]) {
        this.params = {
          fabricAttrTypeEn: val[0].value,
          fabricAttrTypeCn: val[0].label,
        };
      } else {
        this.params = {
          fabricAttrTypeEn: "",
          fabricAttrTypeCn: "",
        };
      }
      this.$emit("leftClick", {
        fabricAttrTypeEn: this.params.fabricAttrTypeEn,
      });
    },
    clearSelected() {
      this.$refs.leftTable.clearSelected();
    },
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      let key;
      if (ref === "add") {
        key = "tips_add";
        if (!this.params.fabricAttrTypeEn) {
          this.$message.warning(
            this.$l("tips_select_type") || "请选择左侧类型!"
          );
          return;
        }
      } else if (ref === "edit") {
        key = "tips_edit";
      } else if (ref === "detail") {
        key = "tips_view";
      }
      // 设置标题
      this.formOption.title = this.$l(key) || opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.formLoad(ref, val);
      }, 0);
    },
    update(code, val) {
      let msg = "";
      if (val === "Y") {
        msg = this.$l("INDEX.tips_question_recover") || "是否恢复?";
      } else if (val === "N") {
        msg = this.$l("INDEX.tips_question_delete") || "是否删除?";
      }
      this.$confirm(msg, this.$l("INDEX.tips_question_title") || "提示", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      }).then(() => {
        this.$api
          .masterFabricAttributesUpdateStatusApi({
            fabricAttrCode: code,
          })
          .then(() => {
            this.$message.success(
              this.$l("INDEX.tips_operate_ok") || "操作成功!"
            );
            this.$emit("submit");
          });
      });
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
  },
};
</script>